var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.value == 1 ? 'score-1' : 'score-4'},[_vm._v("\n  "+_vm._s(_vm.value == 1 ? 'High Value' : 'Not High Value')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }